import gql from 'graphql-tag';
import { OrganizationId, SegmentDataStub, IInterval } from '@kaizenplatform/intelligence-entity';
import GraphQLClient from '../../adapter/GraphQLClient';
import sleep from '../../utility/sleep';
import SegmentData, { ISegmentData } from '@kaizenplatform/intelligence-entity/dist/entity/SegmentData';

class SegmentWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public salesBySegmentsStub = async (): Promise<SegmentData[]> => {
    await sleep(2000);
    return [new SegmentDataStub(), new SegmentDataStub()];
  };

  public salesBySegments = async (organizationId: OrganizationId, periods: IInterval[]): Promise<SegmentData[]> => {
    const result = await this.graphqlClient.query(
      gql`
        query salesBySegments($organizationId: ID!, $periods: [IntervalInput!]!) {
          salesBySegments(organizationId: $organizationId, periods: $periods) {
            label
            device {
              label
              value
            }
            gender {
              label
              value
            }
            ageGroup {
              label
              value
            }
          }
        }
      `,
      {
        organizationId,
        periods,
      },
    );

    return result.salesBySegments.map((segment: ISegmentData) => SegmentData.fromJSON(segment));
  };

  public visitorsBySegmentsStub = async (): Promise<SegmentData[]> => {
    await sleep(2000);

    return [new SegmentDataStub(), new SegmentDataStub()];
  };

  public visitorsBySegments = async (organizationId: OrganizationId, periods: IInterval[]): Promise<SegmentData[]> => {
    const result = await this.graphqlClient.query(
      gql`
        query visitorsBySegments($organizationId: ID!, $periods: [IntervalInput!]!) {
          visitorsBySegments(organizationId: $organizationId, periods: $periods) {
            label
            device {
              label
              value
            }
            gender {
              label
              value
            }
            ageGroup {
              label
              value
            }
          }
        }
      `,
      {
        organizationId,
        periods,
      },
    );

    return result.visitorsBySegments.map((segment: ISegmentData) => SegmentData.fromJSON(segment));
  };
}

export default SegmentWebApi;
